import { Component, Show } from "solid-js";
import { A } from "@solidjs/router";
import { setMenu, SubMenu, submenu, menu } from "../../app";
import { CMS } from "../cms/cms";
import "./navbar.scss";
import "./jetmenu.scss";
import "./jetmenu-custom.scss";

export const JetMenu : Component = () => {
    const clear = () => setMenu("");
    type MenuItemType = {
        submenu: SubMenu;
        label?: string;
        block: string;
        url?: string;
    };
    const MenuItem : Component<MenuItemType> = (props) =>
    <li classList={{ ["active"]: submenu() == props.submenu }}>
        <A href={props.url ? props.url : "/" + props.block}><CMS id={"2nd-arc-salon/navigation::" + props.block} text>{props.label || props.submenu}</CMS></A>
    </li>;
    return (
    <div style={{ "position": "relative" }}>
        <div class="navbar-fixed-top salon-navbar">
            <ul class="jetmenu blue">
                <li class="left">
                    <a href="/"><span class="fa fa-home"></span></a>
                </li>
                <li onmouseenter={() => setMenu("Contents") } onmouseleave={clear} classList={{ "menu-active": menu() == "Contents" }}>
                    <a href="javascript:void(0)">
                        <CMS id="2nd-arc-salon/navigation::contents" text>Contents</CMS>
                    </a>
                    <Show when={menu() == "Contents"}>
                        <ul class="dropdown">
                            <MenuItem submenu="Introduction" block="introduction" url="/" />
                            <MenuItem submenu="Chairman's Message" block="chairmans-message" />
                            <MenuItem submenu="Jurors" block="jurors" />
                            <MenuItem submenu="Artist Index" block="artist-index" />
                            <MenuItem submenu="About Us" block="about-us" />
                            <MenuItem submenu="Search" block="search" />
                        </ul>
                    </Show>
                </li>
                <li onmouseenter={() => setMenu("Main Awards") } onmouseleave={clear} classList={{ "menu-active": menu() == "Main Awards" }}>
                    <a href="javascript:void(0)">
                        <CMS id="2nd-arc-salon/navigation::awards" text>Awards</CMS>
                    </a>
                    <Show when={menu() == "Main Awards"}>
                        <ul class="dropdown">
                            <MenuItem submenu="Best in Show" block="best-in-show" />
                            <MenuItem submenu="Bouguereau Award" block="bouguereau-award" />
                            <MenuItem submenu="Other Awards" block="other-awards" />
                        </ul>
                    </Show>
                </li>
                <li onmouseenter={() => setMenu("Category Awards") } onmouseleave={clear} classList={{ "menu-active": menu() == "Category Awards" }}>
                    <a href="javascript:void(0)">
                        <CMS id="2nd-arc-salon/navigation::category-awards" text>Category Awards</CMS>
                    </a>
                    <Show when={menu() == "Category Awards"}>
                        <ul class="dropdown">
                            <MenuItem submenu="Figurative" block="figurative" />
                            <MenuItem submenu="Imaginative Realism" block="imaginative-realism" />
                            <MenuItem submenu="Landscape" block="landscape" />
                            <MenuItem submenu="Animals" block="animals" />
                            <MenuItem submenu="Sculpture" block="sculpture" />
                            <MenuItem submenu="Drawing" block="drawing" />
                            <MenuItem submenu="Still Life" block="still-life" />
                        </ul>
                    </Show>
                </li>
            </ul>
        </div>
    </div>);
};